import React from 'react'
import "./Checkout.css"
// import add_1 from './img/add_1.png'
import banner_3 from './img/banner_3.png'
import Subtotal from './Subtotal';
import {
    BrowserRouter as Link
} from "react-router-dom";
import { useStateValue } from './StateProvider'

import CheckoutProduct from './CheckoutProduct';


function Checkout() {
    const [{ basket,user}, dispatch] = useStateValue();

    return (
        <div className="checkout">
            <div className="checkout__left">
                <img className="checkout__ad" src={banner_3} alt=""  style={{'width':'100%','height':'150px'}} />
                <div>
                    <h3>Hello, {user?.email}</h3>
                    <h2 className="checkout__title">Your Shoping Basket</h2>
                  {basket.map(item =>(
                      //Improve image size
                        <CheckoutProduct id={item.id} title={item.title} price={item.price} image={item.image} rating={item.rating}/>
                  ))}
                </div>
            </div>
            <div className="checkout__right">
                <Subtotal />
            </div>
        </div>
    )
}

export default Checkout
